import { Component, effect, inject, OnInit } from '@angular/core';
import { PageHeaderComponent } from '@/components/shared/page-header/page-header.component';
import { DataTableBuilderComponent } from '@/components/data-table-builder/data-table-builder.component';
import { CommonModule } from '@angular/common';
import { ButtonModule } from 'primeng/button';
import { TranslateModule } from '@ngx-translate/core';
import { DacGeneralParamsService } from './dac-general-params.service';
import { MessageService } from 'primeng/api';
import { TranslateService } from '@ngx-translate/core';
import { ParametrageGeneralDac } from '@/types';
import { DataTableServerQuery, DynamicDataTable } from '@/components/data-table-builder/data-table.types';
import { createServerQuery } from '@/components/data-table-builder/server-query';
import { getDacGeneralParamsDataTableStructure } from './utils/dac-general-params.datatable-object';
import { DacGeneralParamsRepository } from '@/store/dac-general-params-state/dac-general-params-state.repository';
import { Router } from '@angular/router';
import { BehaviorSubject, finalize } from 'rxjs';

@Component({
  selector: 'sm-dac-general-params',
  imports: [CommonModule, PageHeaderComponent, DataTableBuilderComponent, ButtonModule, TranslateModule],
  templateUrl: './dac-general-params.component.html',
  styleUrl: './dac-general-params.component.scss',
})
export class DacGeneralParamsComponent implements OnInit {
  readonly dacGeneralParamsService = inject(DacGeneralParamsService);
  readonly dacGeneralParamsRepository = inject(DacGeneralParamsRepository);
  readonly router = inject(Router);
  messageService = inject(MessageService);
  translate = inject(TranslateService);

  breadcrumb = [{ label: 'Paramètrage', routerLink: ['settings'] }, { label: 'dacGeneralParams.title' }];

  data: ParametrageGeneralDac[] = [];
  totalRecords = 0;
  serverQuery: DataTableServerQuery = createServerQuery({ initialPageSize: 10, initialSortBy: 'updatedAt', initialSortOrder: 'desc' });
  dataTableObject?: DynamicDataTable = getDacGeneralParamsDataTableStructure({
    createAction: () => {
      this.router.navigate(['/settings', 'general-parameters', 'new']);
    },
    store: this.dacGeneralParamsRepository,
    serverQuery: this.serverQuery,
    rowActions: {
      // inspectAction: () => {
      //   console.log('inspect');
      // },
      editAction: row => {
        this.router?.navigate(['/settings', 'general-parameters-edit', row.id]);
      },
      // deleteAction: row => {
      //   console.log('delete', row);
      // },
    },
  });
  loading = new BehaviorSubject<boolean>(false);
  exporting = new BehaviorSubject<boolean>(false);

  constructor() {
    let firstRun = true;

    effect(() => {
      const page = this.serverQuery.page();
      const size = this.serverQuery.pageSize();
      const sortBy = this.serverQuery.sortBy();
      const sortOrder = this.serverQuery.sortOrder();
      const search = this.serverQuery.search();
      const sort = sortBy ? `${sortBy},${sortOrder}` : '';
      const filter = this.serverQuery.filterString();

      if (firstRun) {
        firstRun = false;
        return;
      }

      this.loadData(page, size, search, sort, filter);
    });
  }

  ngOnInit(): void {
    this.loadData();
  }

  loadData(page = 0, size = 10, search = '', sort = '', filter = '') {
    this.loading.next(true);
    this.dacGeneralParamsService.getAll({ page, size, search, sort, filter }).subscribe({
      next: data => {
        this.data = data.content.map(row => ({
          ...row,
          dynaDocsModels_joined: row.dynaDocsModels?.map(m => m.dynaDocsModel.description).join(', ') || '',
        }));
        this.totalRecords = data.totalElements;
        this.loading.next(false);
      },
      error: err => {
        this.loading.next(false);
        this.messageService.add({
          severity: 'error',
          summary: 'Erreur',
          detail: err.error?.message,
        });
      },
    });
  }

  exportToExcel(): void {
    this.exporting.next(true);
    this.dacGeneralParamsService
      .exportToExcel()
      .pipe(finalize(() => this.exporting.next(false)))
      .subscribe({
        error: () => {
          this.messageService.add({
            severity: 'error',
            summary: 'Erreur',
            detail: this.translate.instant('dacGeneralParams.errors.export'),
          });
        },
      });
  }
}
